function quickMoneyFormat(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  let formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    let parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

// let btns = document.querySelectorAll('.quickview_btn');

// function quickViewBtns(buttons) {
//   buttons.forEach((btn) => {
//     btn.addEventListener('click', async (e) => {
//       let quickViewModal = document.querySelector('#quickView');

//       let product = btn.getAttribute('data-handle');

//       if (product) {
//         // let loader = document.querySelector('.global-loader.loader');
//         // loader.classList.remove('hidden');
//         await quickView(product);
//         // quickColorSwatch(btn);
//         document.documentElement.classList.add('overflow-hidden');
//         // loader.classList.add('hidden');
//         quickViewModal.classList.add('quickview_active');
//       }
//     });
//   });
// }

// quickViewBtns(btns);

// async function quickView(product_handle) {
//   const response = await fetch(`/products/${product_handle}.js`);
//   const product = await response.json();
//   let quickViewModal = document.querySelector('#quickView');
//   let format = quickViewModal.getAttribute('data-money-quickview');
//   let form = quickViewModal.querySelector('form');
//   let titleLink = quickViewModal.querySelector('.product_title_link');
//   let title = quickViewModal.querySelector('.product_title');
//   let description = quickViewModal.querySelector('.product_description');
//   let productType = quickViewModal.querySelector('.product_type');
//   let quantity = quickViewModal.querySelector('#quickview_quantity');
//   let img = quickViewModal.querySelector('.product_image');
//   let price = quickViewModal.querySelector('.product_price');
//   let compared_price = quickViewModal.querySelector('.product_compared_price');
//   let variantSelect = quickViewModal.querySelector(
//     ".product_options select[name='id']",
//   );
//   let textType = 'Type';

//   document.querySelector('#quickview_product_id').value =
//     product.variants[0].id;
//   quantity.setAttribute('max', 100); // Set max quantity

//   function removeTags(str) {
//     if (str === null || str === '') return false;
//     else str = str.toString();
//     return str.replace(/(<([^>]+)>)/gi, '');
//   }

//   form.setAttribute('id', `product_form_${product.id}`);
//   titleLink.setAttribute('href', product.url);
//   title.innerText = product.title;
//   description.innerHTML = product.description;
//   productType.innerText = `${product.type}`;

//   price.innerText = quickMoneyFormat(product.price, format);
//   if (compared_price) {
//     compared_price.innerText = quickMoneyFormat(
//       product.compare_at_price,
//       format,
//     );
//   }

//   img.setAttribute('src', `${product.featured_image}`);

//   // **✅ Fix: Add event listeners for + and - buttons**
//   let decreaseBtn = quickViewModal.querySelector('.decrease');
//   let increaseBtn = quickViewModal.querySelector('.increase');

//   if (decreaseBtn && increaseBtn && quantity) {
//     decreaseBtn.addEventListener('click', () => {
//       let currentValue = parseInt(quantity.value);
//       let minValue = parseInt(quantity.getAttribute('min')) || 1;
//       if (currentValue > minValue) {
//         quantity.value = currentValue - 1;
//       }
//     });

//     increaseBtn.addEventListener('click', () => {
//       let currentValue = parseInt(quantity.value);
//       let maxValue = parseInt(quantity.getAttribute('max')) || 100;
//       if (currentValue < maxValue) {
//         quantity.value = currentValue + 1;
//       }
//     });
//   }
// }

// Delegate click event for .quickview_btn
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.quickview_btn');
  if (!btn) return;

  const productHandle = btn.getAttribute('data-handle');
  const quickViewModal = document.querySelector('#quickView');

  if (productHandle && quickViewModal) {
    document.documentElement.classList.add('overflow-hidden');
    await quickView(productHandle);
    quickViewModal.classList.add('quickview_active');
  }
});

async function quickView(product_handle) {
  const response = await fetch(`/products/${product_handle}.js`);
  const product = await response.json();
  const quickViewModal = document.querySelector('#quickView');
  const format = quickViewModal.getAttribute('data-money-quickview');
  const form = quickViewModal.querySelector('form');
  const titleLink = quickViewModal.querySelector('.product_title_link');
  const title = quickViewModal.querySelector('.product_title');
  const description = quickViewModal.querySelector('.product_description');
  const productType = quickViewModal.querySelector('.product_type');
  const quantity = quickViewModal.querySelector('#quickview_quantity');
  const img = quickViewModal.querySelector('.product_image');
  const price = quickViewModal.querySelector('.product_price');
  const compared_price = quickViewModal.querySelector('.product_compared_price');

  document.querySelector('#quickview_product_id').value = product.variants[0].id;
  quantity.setAttribute('max', 100); // Set max quantity

  form.setAttribute('id', `product_form_${product.id}`);
  titleLink.setAttribute('href', product.url);
  title.innerText = product.title;
  description.innerHTML = product.description;
  productType.innerText = product.type;

  price.innerText = quickMoneyFormat(product.price, format);
  if (compared_price && product.compare_at_price) {
    compared_price.innerText = quickMoneyFormat(product.compare_at_price, format);
  }

  img.setAttribute('src', product.featured_image);

  // Quantity increase/decrease logic
  const decreaseBtn = quickViewModal.querySelector('.decrease');
  const increaseBtn = quickViewModal.querySelector('.increase');

  if (decreaseBtn && increaseBtn && quantity) {
    decreaseBtn.onclick = () => {
      let currentValue = parseInt(quantity.value) || 1;
      let minValue = parseInt(quantity.getAttribute('min')) || 1;
      if (currentValue > minValue) {
        quantity.value = currentValue - 1;
      }
    };

    increaseBtn.onclick = () => {
      let currentValue = parseInt(quantity.value) || 1;
      let maxValue = parseInt(quantity.getAttribute('max')) || 100;
      if (currentValue < maxValue) {
        quantity.value = currentValue + 1;
      }
    };
  }
}

let modalClose = document.querySelector('#quickView .modal-close');
modalClose.addEventListener('click', (e) => {
  let quickViewModal = document.querySelector('#quickView');
  quickViewModal.classList.remove('quickview_active');
  document.documentElement.classList.remove('overflow-hidden');
  btns.forEach((btn) => {
    btn.setAttribute('aria-expanded', false);
  });
});

window.addEventListener('keyup', (e) => {
  let quickViewModal = document.querySelector('#quickView');
  if (
    e.key == 'Escape' &&
    quickViewModal.classList.contains('quickview_active')
  ) {
    quickViewModal.classList.remove('quickview_active');
    document.documentElement.classList.remove('overflow-hidden');
  }
});
